export type TicketFilter = 'open' | 'acknowledged' | 'investigating' | 'resolved' | 'all';

interface Props {
  current: TicketFilter;
  counts: Record<TicketFilter, number>;
  onChange: (f: TicketFilter) => void;
}

const TABS: { id: TicketFilter; label: string }[] = [
  { id: 'open', label: 'Open' },
  { id: 'acknowledged', label: 'Acknowledged' },
  { id: 'investigating', label: 'Investigating' },
  { id: 'resolved', label: 'Resolved' },
  { id: 'all', label: 'All' },
];

export function SupportTicketFilters({ current, counts, onChange }: Props) {
  return (
    <div className="tab-bar" style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
      {TABS.map(tab => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`btn ${current === tab.id ? 'btn-primary' : 'btn-secondary'}`}
          style={{ padding: '6px 14px' }}
        >
          {tab.label} ({counts[tab.id] ?? 0})
        </button>
      ))}
    </div>
  );
}
